import React, { Component } from 'react'

import '../../assets/css/0020_objects/0950_obj_challenge_gain_level.css'

class ObjChallengeGainLevel extends Component {
	constructor() {
		super()
		this.state = {}
	}
	
	render() {
		const {participation} = this.props;
        const challenge = participation?.Challenge;
        const conditionActive = participation?.Challenge?.Conditions?.find(o => o.ChallengeCondition_EnableVariableGain);

		return (<>{ participation && challenge &&  (participation.Challenge.Challenge_EnableVariableMaxGain || conditionActive) &&
			<div className="obj_challenge_gain-level">
				<div className="ctn_challenge_gain-level">

					<div className="col-item item_level-label">
						<div className="obj_challenge-gainlevel-item-level">
							<span>Gain selon<br /> les ventes<br /> sur la période</span>
						</div>

						<div className="obj_challenge-gainlevel-item-label">
							<span>
                                Evolution<br /> 
                                {challenge.Challenge_StartDate && <>{new Date(challenge.Challenge_StartDate).getFullYear()} vs {new Date(challenge.Challenge_StartDate).getFullYear() - 1}</>}
                            </span>
						</div>
					</div>

					<div className="col-item item_level-level1">
						<div className="ctn_item_level">
							<div className="obj_challenge-gainlevel-item-label">
								<p>
                                    {challenge.Challenge_EnableVariableMaxGain 
                                        ? challenge.Challenge_MaxMinGain && <>Gagnez jusqu'à <strong>{challenge.Challenge_MaxMinGain}<sup>€</sup></strong></>
                                        : conditionActive?.ChallengeCondition_VariableGainMinPerUnity && <>Gain par produit vendu <strong>{conditionActive.ChallengeCondition_VariableGainMinPerUnity}<sup>€</sup></strong></>
                                    }
                                </p>
							</div>
						</div>
						<div className="ctn_item_label">
							<div className="obj_item_label">
								<p>Au moins<br /><strong>1 boîte de plus</strong></p>
							</div>
						</div>
					</div>
					<div className="col-item item_level-level2">
						<div className="ctn_item_level">
							<div className="obj_challenge-gainlevel-item-label">
                            <p>
                                    {challenge.Challenge_EnableVariableMaxGain 
                                        ? challenge.Challenge_MaxGain && <>Gagnez jusqu'à <strong>{challenge.Challenge_MaxGain}<sup>€</sup></strong></>
                                        : conditionActive.ChallengeCondition_MaxGainPerUnity && <>Gain par produit vendu <strong>{conditionActive.ChallengeCondition_MaxGainPerUnity}<sup>€</sup></strong></>
                                    }
                                </p>
							</div>
						</div>
						<div className="ctn_item_label">
							<div className="obj_item_label">
								<p>{ challenge.Challenge_EvolutionPercent && <>Au moins<br /><strong>{challenge.Challenge_EvolutionPercent}%</strong></>}</p>
							</div>
						</div>
					</div>

				</div>
			</div>
        }</>)
	}
}

export default ObjChallengeGainLevel